<div class="without-registration">
  <span class="without-registration-icon" [ngClass]="icon ? icon : ''"></span>
  <h4 class="d-none d-lg-block  without-registration-text" [ngClass]="{'send':efect}"><span
    [ngClass]="{'tt':efect}">{{ text
  }}</span></h4>
  @if (mostrarAction) {
    <a (click)="clickB()" class="btn btn-primary  mt-4" target="_blank">{{textAction}}</a>
  }
</div>